/* eslint-disable max-lines */
// 外部客户达成率统计表
export const customerColumnConfig = {
    height: '200px',
    industryColumns: [
        {
            label: '行业名称',
            prop: 'angleName'
        },
        {
            label: 'KPI达成率',
            prop: 'kpiAchievementRate'
        },
        {
            label: '排名',
            prop: 'kpiAchievementRank'
        },
        {
            label: 'TOP客户KPI合格率',
            prop: 'topPassRate'
        },
        {
            label: 'CKA客户KPI合格率',
            prop: 'ckaPassRate'
        }
    ],
    companyColumns: [
        {
            label: '分公司名称',
            prop: 'angleName'
        },
        {
            label: 'KPI达成率',
            prop: 'kpiAchievementRate'
        },
        {
            label: '排名',
            prop: 'kpiAchievementRank'
        },
        {
            label: 'TOP客户KPI合格率',
            prop: 'topPassRate'
        },
        {
            label: 'CKA客户KPI合格率',
            prop: 'ckaPassRate'
        }
    ],
    businessCenterColumns: [
        {
            label: '经营中心名称',
            prop: 'angleName'
        },
        {
            label: 'KPI达成率',
            prop: 'kpiAchievementRate'
        },
        {
            label: '排名',
            prop: 'kpiAchievementRank'
        },
        {
            label: 'TOP客户KPI合格率',
            prop: 'topPassRate'
        },
        {
            label: 'CKA客户KPI合格率',
            prop: 'ckaPassRate'
        }
    ],
    seriesColumns: [
        {
            label: '客户系名称',
            prop: 'angleName'
        },
        {
            label: 'KPI达成率',
            prop: 'kpiAchievementRate'
        },
        {
            label: '排名',
            prop: 'kpiAchievementRank'
        },
        {
            label: 'TOP客户KPI合格率',
            prop: 'topPassRate'
        },
        {
            label: 'CKA客户KPI合格率',
            prop: 'ckaPassRate'
        }
    ]

};

// 客户KPI明细
export const customerKpiColumnsConfig = {
    height: '200px',
    columns: [
        {
            label: '记录号',
            prop: 'recordNumber',
            width: '130px'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: '180px'
        },
        {
            label: '服务平台',
            prop: 'siteName',
            width: '110px'
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            width: '120px'
        },
        {
            label: '业务类型',
            prop: 'businessTypeName'
        },
        {
            label: '专司',
            prop: 'specialDepartmentName'
        },
        {
            label: '服务经理',
            prop: 'serviceManagerName'
        },
        {
            label: '客户系',
            prop: 'customerGroupName'
        },
        {
            label: '客户等级',
            prop: 'customerLevelName'
        },
        {
            label: '行业',
            prop: 'industryCategoryName'
        },
        {
            label: '片区',
            prop: 'areaName'
        },
        {
            label: '分公司',
            prop: 'companyName'
        },
        {
            label: '客户KPI满分',
            prop: 'kpiFullScore'
        },
        {
            label: '客户KPI实际得分',
            prop: 'actualScore',
            width: '110px'
        },
        {
            label: '供应商排名',
            prop: 'supplierRanking'
        },
        {
            label: '失分原因分析',
            prop: 'losePointsReason',
            width: '180px'
        }
    ]

};

// 重大客诉
export const complaintDetailColumnsConfig = {
    height: '200px',
    defaultSort: {
        prop: 'incomeFee', order: 'descending'
    },
    columns: [{
        label: '记录号',
        prop: 'recordNo',
        width: '140px'
    }, {
        label: '发生时间',
        prop: 'periodWid',
        width: '100px'
    }, {
        label: '片区',
        prop: 'areaName',
        width: '70px'
    }, {
        label: '分公司',
        prop: 'companyName'
    }, {
        label: '经营中心',
        prop: 'siteNameLev2'
    }, {
        label: '服务平台',
        prop: 'siteName'
    }, {
        label: '客户名称',
        prop: 'customerName',
        width: '180px'

    }, {
        label: '客户系名称',
        prop: 'customerGroupName'
    }, {
        label: '客户等级',
        prop: 'customerLevelName'
    }, {
        label: '行业名称',
        prop: 'typeName'
    }, {
        label: '专司名称',
        prop: 'ebcdName'
    }, {
        label: '定则原因',
        prop: 'dutyReasonName',
        width: '180px'
    }, {
        label: '问题描述',
        prop: 'problemDescription',
        width: '200px'
    }, {
        label: '重大投诉起数',
        prop: 'majorComplaintsNumber'
    }, {
        label: '重大分类',
        prop: 'majorComplaintsCategory'
    }
    ]

};
// 搜索条件
export const searchListConfig = [
    {
        prop: 'ebcdCode',
        name: '专业公司',
        type: 'select',
        placeholder: '请选择专业公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-complaint-search-ebcdCode'
    },
    {
        prop: 'industryCategory',
        name: '行业大类',
        type: 'cascader',
        props: {
            multiple: true,
            value: 'code',
            label: 'name'
        },
        placeholder: '请选择行业大类',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-complaint-search-industryCategory'
    },
    {
        prop: 'areaCode',
        name: '片区',
        type: 'select',
        placeholder: '请选择片区',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-complaint-search-areaCode'
    },
    {
        prop: 'subBranchCode',
        name: '分公司',
        type: 'select',
        placeholder: '请选择分公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-complaint-search-subBranchCode'
    },
    // {
    //     prop: 'dazhuangyegongsi',
    //     name: '大专司',
    //     type: 'select',
    //     placeholder: '请选择大专司',
    //     multiple: false,
    //     defaultValue: '整体',
    //     options: [
    //         {
    //             code: '整体',
    //             name: '整体'
    //         },
    //         {
    //             code: '城配送装',
    //             name: '城配送装'
    //         },
    //         {
    //             code: '零担干线',
    //             name: '零担干线'
    //         },
    //         {
    //             code: '生产物流',
    //             name: '生产物流'
    //         },
    //         {
    //             code: '非专司',
    //             name: '非专司'
    //         }
    //     ]
    // },
    {
        prop: 'customerlevelName',
        name: '客户等级',
        type: 'radio',
        placeholder: '请选择客户等级',
        fixed: 'left',
        className: 'bigData-btn-home-sub-org-complaint-search-customerlevelName'
    },
    {
        prop: 'timeStatus',
        name: '时间',
        type: 'time',
        placeholder: '请选择时间',
        fixed: 'left',
        className: 'bigData-btn-home-sub-org-complaint-search-timeStatus'
    }

];

export const updateTimeBigdataList = {
    resetClassName: 'bigData-btn-home-sub-org-complaint-reset',
    closeClassName: 'bigData-btn-home-sub-org-complaint-close'
};
